import React from 'react';
import './home.style.css';
// import video from "../../assets/compressed/videoHome.mp4";
import SEO from '../../SEO';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <>
      <SEO 
        title="Wild Chips Poker - Host your own poker game and invite your friends"
        description="Join the jungle poker revolution in Wild Chips Poker! Battle opponents, collect rare chips, and master unique poker strategies in this thrilling multiplayer card game. Download free for Windows or Mac!"
        keywords="wild chips poker, jungle poker, poker game, multiplayer card game, online poker, jungle adventure, poker strategy, casino game, poker host game, poker game host, poker game creator, poker game organizer"
        ogImage="/images/bgHome-min.png"
        canonicalUrl="https://wildchipspoker.com"
      />
      <div className="all-pages-padding home-container">
        {/* <video
          className="background-video"
          autoPlay
          muted
          playsInline
          onLoadedMetadata={(e) => {
            const video = e.target as HTMLVideoElement;
            video.playbackRate = 0.8; // Set initial playback rate to half speed
          }}
          onTimeUpdate={(e) => {
            const video = e.target as HTMLVideoElement;
            // console.log("Time updated", video.currentTime, video.duration);
            // When near the end, slow down playback significantly
            if (video.currentTime > video.duration - 0.2) {
              video.pause();
            }
          }}
          // onEnded={(e) => {
          //   console.log("Video ended");
          //   const video = e.target as HTMLVideoElement;
          //   video.pause();  // Pause the video when it ends
          // }}
        >
          <source src={video} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <div className="download-panel">
          <h1>Start the Hunt for Wild Chips Now!</h1>
          <p><Link to="/game" className="download-button">Play Now</Link></p>
          {/* <p>Or</p> */}
          {/* <div className="download-buttons">
            <div className="download-option">
              <h2>Windows</h2>
              <a 
                href={"/installables/WildChipsPokerInstaller.exe"}
                className="download-button"
                download="WildChipsPokerInstaller.exe"
              >
                Download for Windows
              </a>
            </div>
            <div className="download-option">
              <h2>Mac</h2>  
              <a 
                href="/installables/WildChipsPokerInstaller.pkg" 
                className="download-button"
                download="WildChipsPokerInstaller.pkg"
              >
                Download for Mac
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
